@let waitingForBotResponse = botatoChatManager.waitingForBotResponse$ | async;

@if (isDataLoaded) {
    @if (studyProgresses !== undefined && studyProgresses.length > 0) {
        <div class="mm-profile-page">
            <div [class.micromate-profile-study-progresses-justify-space-evenly]="studyProgresses.length> 3"
                 class="micromate-profile-study-progresses">
                <div *ngFor="let studyProgress of studyProgresses"
                     class="micromate-profile-study-progress"
                     [class.micromate-profile-study-progress-not-available]="!studyProgress.learningPackageIsAvailable">
                    <div
                        [class.mm-tutor]="studyProgress.type === 'managedTutor'"
                        [class.micromate-profile-study-progress-gole-not-done]="studyProgress.learningGoal !== undefined && studyProgress.studyProgress !== undefined && studyProgress.studyProgress < studyProgress.learningGoal"
                        class="micromate-profile-study-progress-card">

                        <div class="micromate-profile-study-progress-markers">
                            <div class="micromate-profile-study-progress-markers-stickers">
                                <div
                                    *ngIf="studyProgress.shouldShowAmountOfForgettingIndicator"
                                    class="micromate-profile-study-progress-sticker mm-profile-progress-amount-of-forgetting-sticker"
                                    title="{{ 'learningGoal.forgettingApplied' | translate }}">
                                    {{ studyProgress.amountOfForgetting }}<span
                                    class="mm-profile-progress-amount-of-forgetting-sticker-percent">%</span>
                                </div>

                                <div *ngIf="studyProgress.shouldShowLearnIndicator"
                                     class="micromate-profile-study-progress-sticker micromate-profile-study-progress-forgetting-sticker"
                                     title="{{ 'learningGoal.forgettingApplied' | translate }}">

                                    <app-icon icon="user-clock-solid"
                                              class="micromate-profile-study-progress-forgetting-sticker-icon"></app-icon>
                                </div>

                                <div
                                    *ngIf="studyProgress.learningGoal !== undefined && studyProgress.studyProgress !== undefined && studyProgress.studyProgress >= studyProgress.learningGoal"
                                    class="micromate-profile-study-progress-sticker
                         micromate-profile-study-progress-check-sticker"
                                    title="{{ 'learningGoal.checkSticker' | translate }}">
                                    <app-icon [icon]="'check-light'"
                                              class="micromate-profile-study-progress-check-sticker-icon"></app-icon>
                                </div>
                            </div>

                        </div>
                        <div class="micromate-profile-study-progress-card-content">

                            <div class="micromate-profile-study-progress-learning-package-name">
                                {{ studyProgress.learningPackageName }}
                            </div>

                            <div class="micromate-profile-study-progress-content-tab">
                                @if (studyProgress.type === 'learningPackage') {
                                    <mm-learning-progress-visualization
                                        [learningGoal]="studyProgress?.learningGoal"
                                        [studyProgressScaleName]="studyProgress?.studyProgressScaleName"
                                        [studyProgress]="studyProgress.studyProgress"
                                        [learningPackageIsAvailable]="studyProgress.learningPackageIsAvailable"
                                        [manualActivation]="studyProgress.manualActivation"
                                        [reachableLearningProgress]="studyProgress.reachableLearningProgress">
                                    </mm-learning-progress-visualization>
                                }

                                @if (studyProgress.type === 'managedTutor') {
                                    <mm-learning-progress-visualization
                                        [learningGoal]="studyProgress?.learningGoal"
                                        [studyProgressScaleName]="studyProgress?.studyProgressScaleName"
                                        [studyProgress]="studyProgress.studyProgress"
                                        [learningPackageIsAvailable]="studyProgress.learningPackageIsAvailable"
                                        [manualActivation]="studyProgress.manualActivation"
                                        [reachableLearningProgress]="studyProgress.reachableLearningProgress">
                                    </mm-learning-progress-visualization>
                                }
                            </div>

                        </div>

                        <div class="mm-profile-study-progress-tabs-navigation"
                             [class.mm-profile-study-progress-tabs-navigation-hidden]="!studyProgress.learningPackageIsAvailable">
                            <button type="button"
                                    (click)="learnPackage(studyProgress.learningPackageId)"
                                    [attr.disabled]="isStartingLearningSessionInProgress || waitingForBotResponse ? true : null"
                                    class="mm-profile-study-progress-learn-button"
                                    title="{{ ('learningGoal.learnButton.' + studyProgress.type) | translate }}">
                                <app-icon [icon]="'graduation-play'"
                                          class="mm-profile-study-progress-tabs-learn-button-cap"></app-icon>
                            </button>

                            <div class="mm-profile-study-progress-tabs-navigation-panel">
                                <button type="button"
                                        (click)="openInsightPopup(studyProgress)"
                                        class="mm-profile-study-progress-tabs-navigation-button"
                                        title="{{ ('learningGoal.navLearningPackageInfo.' + studyProgress.type) | translate }}">
                                    <app-icon [icon]="'chart-mixed'"
                                              class="mm-profile-study-progress-tabs-navigation-button-icon"></app-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    @if(studyProgresses === undefined || studyProgresses.length === 0) {
        <div class="mm-profile-page mm-profile-page-no-data">
            <div [class.micromate-profile-study-no-data-dark-mode]="darkMode"
                 class="micromate-profile-study-no-data">
                <div class="micromate-profile-study-no-data-message">{{ 'learningGoal.noData' | translate }}</div>
            </div>
        </div>

    }
}

